var _path, _path2, _g, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8334 12.626H7.99805C7.72205 12.626 7.49805 12.402 7.49805 12.126C7.49805 11.85 7.72205 11.626 7.99805 11.626H12.8334C13.1094 11.626 13.3334 11.85 13.3334 12.126C13.3334 12.402 13.1094 12.626 12.8334 12.626Z",
    fill: "#23273B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3488_1906",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333984 0H11.7877V12.6264H0.333984V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3488_1906)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74083 1.34443L1.46417 9.19443C1.35017 9.3371 1.30817 9.5211 1.35017 9.69776L1.80417 11.6211L3.83017 11.5958C4.02283 11.5938 4.20083 11.5078 4.31883 11.3611C6.4635 8.67776 10.5522 3.56176 10.6682 3.41176C10.7775 3.23443 10.8202 2.98376 10.7628 2.74243C10.7042 2.4951 10.5502 2.2851 10.3282 2.1511C10.2808 2.11843 9.1575 1.24643 9.12283 1.2191C8.70017 0.880428 8.0835 0.939095 7.74083 1.34443ZM1.4095 12.6264C1.17817 12.6264 0.976834 12.4678 0.922834 12.2418L0.376834 9.92776C0.264167 9.44843 0.376167 8.95376 0.683501 8.56976L6.9635 0.715095C6.96617 0.712428 6.96817 0.709095 6.97083 0.706428C7.6595 -0.116905 8.90483 -0.238238 9.74483 0.435762C9.77817 0.461762 10.8935 1.32843 10.8935 1.32843C11.2988 1.56976 11.6155 2.0011 11.7355 2.51176C11.8548 3.0171 11.7682 3.53843 11.4902 3.97909C11.4695 4.01176 11.4515 4.03976 5.0995 11.9864C4.7935 12.3678 4.33483 12.5898 3.84217 12.5958L1.41617 12.6264H1.4095Z",
    fill: "#23273B"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81626 5.78959C9.7096 5.78959 9.60293 5.75559 9.5116 5.68625L5.87693 2.89425C5.65826 2.72625 5.61693 2.41292 5.78493 2.19292C5.9536 1.97425 6.26693 1.93359 6.48626 2.10159L10.1216 4.89292C10.3403 5.06092 10.3816 5.37492 10.2129 5.59425C10.1149 5.72225 9.96626 5.78959 9.81626 5.78959Z",
    fill: "#23273B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlack);
export default __webpack_public_path__ + "static/media/EditBlack.c545efc602d758ea6d8bd463d14347da.svg";
export { ForwardRef as ReactComponent };